<template>
  <div>
    <!-- Banner notification -->
    <div v-if="!isOnline" class="offline-popup">🚫 {{ $t('network_offline') }}</div>

    <!-- Modal/Dialog alert -->
    <el-dialog
      v-model="showOfflineDialog"
      width="90%"
      :lock-scroll="true"
      top="20vh"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="dialog-content">
        <div class="dialog-icon">🚫</div>
        <h3 class="dialog-title">{{ $t('network_offline_title') }}</h3>
        <p class="dialog-message">
          {{ $t('network_offline_message') }}
        </p>
      </div>
      <template #footer>
        <div class="offline-dialog-footer">
          <el-button type="primary" class="offline-dialog-ok-button" @click="closeDialog">
            <span class="offline-dialog-ok-label">{{ $t('ok') }}</span>
            <KeyenceHTHardKeyButton
              v-if="isKeyenceEnterpriseBrowser"
              :hardkey="KeyenceHardKey.ENTER"
              :function="closeDialog"
              :visible="showOfflineDialog"
              :newLayer="true"
            />
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  name: 'OfflineModal',
  components: {
    KeyenceHTHardKeyButton,
  },
})
export default class OfflineModal extends Vue {
  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }

  isOnline = true
  showOfflineDialog = false

  mounted() {
    this.updateOnlineStatus()
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  }

  unmounted() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  }

  updateOnlineStatus() {
    const previousStatus = this.isOnline
    this.isOnline = navigator.onLine

    // Show dialog when going offline
    if (previousStatus && !this.isOnline) {
      this.showOfflineDialog = true
    }

    // Auto-close dialog when back online
    if (!previousStatus && this.isOnline) {
      this.showOfflineDialog = false
    }
  }

  closeDialog() {
    this.showOfflineDialog = false
  }
}
</script>

<style scoped>
.offline-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ff3b3b;
  color: white;
  text-align: center;
  padding: 14px;
  font-size: 16px;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.dialog-content {
  text-align: center;
  padding: 20px;
}

.dialog-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 600;
  color: #ff3b3b;
  margin: 0 0 12px 0;
}

.dialog-message {
  font-size: 16px;
  color: #606266;
  margin: 0;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.offline-dialog-ok-label {
  flex: 0 0 auto;
  line-height: 1.2;
}
</style>
